import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
/* empty css                       */
const BackInStockButton = ({ onNotifyClick }) => {
  const { getLabel } = useIntl();
  const labels = {
    notify: getLabel("account.wishlist.item.notify"),
    notifyAriaLabel: getLabel("account.wishlist.item.notify.ariaLabel")
  };
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      caption: labels.notify,
      "aria-label": labels.notifyAriaLabel,
      icon: "mail",
      variant: "ghost",
      size: "custom",
      className: "back-in-stock-button",
      onClick: onNotifyClick
    }
  );
};
export {
  BackInStockButton
};
//# sourceMappingURL=BackInStockButton.js.map
